import React from "react";
import { Lock } from "lucide-react";
import { inputCls, labelCls } from "./ui";
import { Row } from "./ProfileTab";
import { fmtDate } from "@/lib/residentApi";

const show = (f, v) => {
  if (v === true) return "Yes";
  if (v === false) return "No";
  if (v === null || v === undefined || v === "") return null;
  if (f.type === "date" && /^\d{4}-\d{2}-\d{2}/.test(String(v))) return fmtDate(v);
  if (f.type === "phone") { const d = String(v).replace(/\D/g, "").replace(/^1(?=\d{10}$)/, ""); if (d.length === 10) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`; }
  return f.options?.find((o) => o[0] === v)?.[1] ?? String(v);
};

const Input = ({ f, value, onChange }) => {
  const tid = `details-input-${f.key.replace(/\./g, "-")}`;
  const v = value ?? "";
  if (f.options) return (
    <select data-testid={tid} value={v} onChange={(e) => onChange(e.target.value || null)} className={inputCls}>
      <option value="">—</option>{f.options.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>);
  if (f.type === "boolean" || f.type === "checkbox") return (
    <select data-testid={tid} value={v === true ? "yes" : v === false ? "no" : ""} onChange={(e) => onChange(e.target.value === "" ? null : e.target.value === "yes")} className={inputCls}>
      <option value="">—</option><option value="yes">Yes</option><option value="no">No</option></select>);
  if (f.type === "textarea") return <textarea data-testid={tid} rows={3} value={v} onChange={(e) => onChange(e.target.value)} className={inputCls} />;
  const type = { date: "date", email: "email", number: "number", phone: "tel" }[f.type] || "text";
  return <input data-testid={tid} type={type} value={v} onChange={(e) => onChange(type === "number" && e.target.value !== "" ? Number(e.target.value) : e.target.value)} className={inputCls} />;
};

const Title = ({ s }) => (
  <div className={`${labelCls} flex items-center gap-1.5`}>{s.label}{s.phi && <><Lock className="h-3 w-3" /> health info · encrypted</>}</div>
);

/** Every intake field — read view, or editable inputs for super admins. */
export function IntakeDetails({ data, values, onChange }) {
  if (!data) return null;
  return (
    <div className="space-y-5" data-testid={onChange ? "details-form" : "details-view"}>
      {data.sections.map((s) => (
        <div key={s.key} data-testid={`details-section-${s.key}`}>
          <Title s={s} />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {s.fields.map((f) => onChange ? (
              <div key={f.key}><label className={labelCls}>{f.label}{f.phi && <Lock className="inline h-2.5 w-2.5 ml-1" />}</label>
                <Input f={f} value={values[f.key]} onChange={(v) => onChange(f.key, v)} />
                {f.key === "phone" && <p className="text-[10px] text-nex-muted mt-1">Also their PACT Life Pass sign-in number and the number texts go to.</p>}</div>
            ) : <Row key={f.key} label={f.label} testId={`details-${f.key.replace(/\./g, "-")}`}>{show(f, values[f.key])}</Row>)}
          </div>
        </div>
      ))}
    </div>
  );
}
